<template>
  <div style="width: 100%; height: 100%; overflow: hidden; position: relative" ref="gamePageRef">
    <!-- <img
      style="width: 100%; height: 100%"
      src="~@/assets/images/intro-bg.png"
    /> -->
    <div class="intro-text">
      <img src="~@/assets/images/game-text.png" />
    </div>
    <div class="game-container">
      <ul class="game-container-content" ref="gameContainerContentRef">
        <li
          v-for="item in list"
          :key="item.id"
          class="game-container-content-li swiper-no-swiping"
          :style="{ backgroundImage: `url(${item.bg_url})` }"
        >
          <ul class="btn-list">
            <li v-for="(it, ix) in item.btnList" :key="ix">
              <template v-if="it.isCode">
                <img :src="it.icon" @touchstart.stop="codeTouch(item.id)" />
                <div class="code-bg" v-show="isShowCodeId == item.id" @touchstart.stop>
                  <img :src="it.code" />
                </div>
              </template>
              <template v-else-if="it.isAndroid || it.IOS">
                <img :src="it.icon" @touchstart="iconTouchDownload(it)" />
              </template>
              <template v-else>
                <a :href="it.url" target="_blank">
                  <img :src="it.icon" />
                </a>
              </template>
            </li>
          </ul>
        </li>
      </ul>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, reactive, ref } from "vue";
import { debounce } from "@/assets/js/common";
import { loadIntroPage, loadAboutPage } from "@/assets/js/preload";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper/modules";
const modules = [Navigation, Pagination, Scrollbar, A11y, Autoplay];

const isShowCodeId = ref("");
const codeTouch = e => {
  if (isShowCodeId.value == e) {
    isShowCodeId.value = "";
  } else {
    isShowCodeId.value = e;
  }
};
const gamePageRef = ref();
const gameContainerContentRef = ref();

const showFun = () => {
  isShowCodeId.value = "";
};

const emits = defineEmits(["slideTo"]);

let lastTime = 0;
const moveFun = e => {
  if (!gameContainerContentRef.value) {
    lastTime = 0;
    return;
  }
  const { scrollTop, scrollHeight, clientHeight } = gameContainerContentRef.value;
  console.log(scrollTop, scrollHeight, clientHeight);
  const time = new Date().getTime();
  if (scrollTop <= 0) {
    if (lastTime && time - lastTime > 60) {
      console.log("prev");
      emits("slideTo", "prev");
    }
  } else if (scrollHeight - clientHeight - scrollTop <= 0) {
    const time = new Date().getTime();
    if (lastTime && time - lastTime > 60) {
      console.log("next");
      emits("slideTo", "next");
    }
  } else {
    lastTime = time;
  }
};
const scrollFun = e => {
  const { scrollTop, scrollHeight, clientHeight } = e.target;
  console.log(scrollTop);
  if (scrollTop < -76) {
    console.log("prev");
    emits("slideTo", "prev");
  } else if (scrollHeight - clientHeight - scrollTop < -111) {
    console.log("next");
    emits("slideTo", "next");
  }
};
const endFun = e => {
  const { scrollTop, scrollHeight, clientHeight } = gameContainerContentRef.value || {};
  if (scrollTop <= 0) {
    setTimeout(() => {
      if (gameContainerContentRef && gameContainerContentRef.value) {
        gameContainerContentRef.value.scrollTop = 3;
      }
    }, 200);
  } else if (scrollHeight - clientHeight - scrollTop <= 3) {
    setTimeout(() => {
      if (gameContainerContentRef && gameContainerContentRef.value) {
        gameContainerContentRef.value.scrollTop = scrollHeight - clientHeight - 3;
      }
    }, 200);
  }
  lastTime = 0;
};
onMounted(() => {
  // loadIntroPage();
  // loadAboutPage();
  document.addEventListener("touchstart", showFun);
  gamePageRef.value.addEventListener("touchend", endFun);
  if (gameContainerContentRef && gameContainerContentRef.value) {
    gameContainerContentRef.value.scrollTop = 3;
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检测iOS设备
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  // 检测Android设备
  const isAndroid = userAgent.indexOf("Android") > -1;

  if (isIOS) {
    gameContainerContentRef.value.addEventListener("scroll", scrollFun);
  } else if (isAndroid) {
    gameContainerContentRef.value.addEventListener("touchmove", moveFun);
  }
});
onUnmounted(() => {
  document.removeEventListener("touchstart", showFun);
  gamePageRef.value?.removeEventListener("touchend", endFun);

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检测iOS设备
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  // 检测Android设备
  const isAndroid = userAgent.indexOf("Android") > -1;

  if (isIOS) {
    gameContainerContentRef.value?.removeEventListener("scroll", scrollFun);
  } else if (isAndroid) {
    gameContainerContentRef.value?.removeEventListener("touchmove", moveFun);
  }
});

const iconTouchDownload = it => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检测iOS设备
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  // 检测Android设备
  const isAndroid = userAgent.indexOf("Android") > -1;

  if (isIOS) {
    if (it.IOS) {
      window.open(it.iosUrl || it.url, "_blank");
    } else {
      alert("暂不支持当前系统");
    }
  } else if (isAndroid) {
    if (it.isAndroid) {
      window.open(it.androidUrl || it.url, "_blank");
    } else {
      alert("暂不支持当前系统");
    }
  }
};

import iconKefu from "@/assets/images/game-kefu.png";
import iconDownload from "@/assets/images/game-download.png";
import iconGift from "@/assets/images/intro-btn-gift.png";

import bg_jlsy from "@/assets/images/game-jlsy.png";
import bg_xlwy from "@/assets/images/game-xlwy.png";
import bg_shdl from "@/assets/images/game-shdl.png";
import bg_shyyl from "@/assets/images/game-shyyl.png";
import bg_htfsl from "@/assets/images/game-htfsl.png";

import code_lnw from "@/assets/images/code-lnw.jpg";

const list = reactive([
  {
    id: "game_1",
    bg_url: bg_jlsy,
    btnList: [
      {
        icon: iconKefu,
        isCode: true,
        code: code_lnw,
      },
      {
        icon: iconGift,
        url: "http://libao.leniu.com/mobile",
      },
      {
        icon: iconDownload,
        url: "http://jlsy.leniu.com/download/index",
      },
    ],
  },
  {
    id: "game_2",
    bg_url: bg_xlwy,
    btnList: [
      {
        icon: iconKefu,
        isCode: true,
        code: code_lnw,
      },
      {
        icon: iconGift,
        url: "http://libao.leniu.com/mobile",
      },
      {
        icon: iconDownload,
        url: "http://xlwy.leniu.com/download/index",
      },
    ],
  },
  {
    id: "game_3",
    bg_url: bg_shdl,
    btnList: [
      {
        icon: iconKefu,
        isCode: true,
        code: code_lnw,
      },
      {
        icon: iconGift,
        url: "http://libao.leniu.com/mobile",
      },
      {
        icon: iconDownload,
        isAndroid: true,
        IOS: true,
        iosUrl: "https://apps.apple.com/cn/app/id6544791110",
        androidUrl: "https://apk-cdn.leniu.com/com.leniu.shdl_d5a965230f.apk",
        // url: "https://shdl.leniu.com/download/index",
      },
    ],
  },
  {
    id: "game_4",
    bg_url: bg_shyyl,
    btnList: [
      {
        icon: iconKefu,
        isCode: true,
        code: code_lnw,
      },
      {
        icon: iconGift,
        url: "http://libao.leniu.com/mobile",
      },
      {
        icon: iconDownload,
        isAndroid: true,
        url: "https://apk-cdn.leniu.com/com.leniu.shyyl_3138fce8b1.apk",
      },
    ],
  },
  {
    id: "game_5",
    bg_url: bg_htfsl,
    btnList: [
      {
        icon: iconKefu,
        isCode: true,
        code: code_lnw,
      },
      {
        icon: iconGift,
        url: "http://libao.leniu.com/mobile",
      },
      {
        icon: iconDownload,
        url: "http://ucenter.leniu.com/#/newGame?gameId=59",
      },
    ],
  },
]);
</script>

<style lang="scss" scoped>
.intro-text {
  position: absolute;
  top: 13.6111rem;
  left: 0;
  right: 0;
  text-align: center;

  img {
    width: 90.3704rem;
    height: 3.0556rem;
  }
}
.game-container {
  position: absolute;
  top: 17.7778rem;
  width: 100%;
  z-index: 3;
  .game-container-content {
    left: 0;
    right: 0;
    margin: auto;
    width: 96.7222rem;
    padding: 0 1rem;
    padding-top: 2rem;
    padding-bottom: 2rem;
    box-sizing: border-box;
    height: 148.7963rem;
    overflow-y: scroll;

    .game-container-content-li {
      position: relative;
      width: 100%;
      height: 32.4074rem;
      background-repeat: no-repeat;
      background-position: 50%;
      background-size: cover;
      // background-image: url(~@/assets/images/game-jlsy.png);
      margin-bottom: 0.9259rem;

      &:nth-child(1) {
        animation: moveKeyframe 0.4s;
      }
      &:nth-child(2) {
        animation: moveKeyframe 0.5s;
      }
      &:nth-child(3) {
        animation: moveKeyframe 0.6s;
      }
      &:nth-child(4) {
        animation: moveKeyframe 0.7s;
      }
      &:nth-child(5) {
        animation: moveKeyframe 0.8s;
      }

      @keyframes moveKeyframe {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(0);
        }
      }

      .btn-list {
        position: absolute;
        left: 5.1852rem;
        top: 17.5rem;
        display: flex;
        z-index: 9;

        > li {
          position: relative;
          width: 11.0185rem;
          height: 11.0185rem;
          margin-right: 5.0926rem;
          &:last-child {
            margin-right: 0;
          }
          img {
            width: 100%;
            height: 100%;
          }
          .code-bg {
            position: absolute;
            right: -23rem;
            top: 30%;
            z-index: 2;
            transform: translateY(-50%);
            height: 17.3148rem;
            width: 18.3333rem;
            padding: 1.3rem;
            background: url(~@/assets/images/code-bg-left.png) center / cover no-repeat;
            background-color: #fff;
            img {
              margin-left: 0.5rem;
            }
          }
        }
      }
    }
  }
  .bottom {
    position: absolute;
    bottom: 0;
    transform: translateY(66%);
    width: 100%;
    height: 40.1852rem;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    background-image: url(~@/assets/images/game-bottom.png);
    filter: blur(2rem); /* 应用模糊效果 */
  }
  .gradient-main {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 16.1852rem;
    overflow: hidden;
    z-index: 9;
  }
  .gradient-blur {
    width: 100%;
    height: 40.1852rem;
    background: linear-gradient(to top, #80c0e3, #c9e4f3); /* 渐变背景 */
    filter: blur(12rem); /* 应用模糊效果 */
  }
}
</style>
